import React, { CSSProperties, FC } from 'react';
import { RecipeProductWithShopifyVariant } from '../../store/state/shopify';
import { formatVariantPrice } from '../../util/format-currency';

interface OwnProps {
  product: RecipeProductWithShopifyVariant;
  style?: CSSProperties;
}

export const ProductCard: FC<OwnProps> = ({ product, style }) => {
  const image =
    product.shopifyVariant.image?.transformedSrc ||
    product.shopifyVariant.product.images[0]?.transformedSrc;

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        ...style,
      }}
    >
      {image && (
        <div
          style={{
            width: '50px',
            height: '50px',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            borderRadius: '6px',
            backgroundImage: `url(${image})`,
            backgroundPosition: 'center',
          }}
        />
      )}

      <div style={{ marginLeft: '8px' }}>
        <span
          style={{
            fontWeight: 'normal',
            fontSize: '18px',
            display: 'block',
            fontFamily: 'var(--font-family-secondary)',
          }}
        >
          {product.shopifyVariant.product.title}
        </span>

        <div
          style={{
            marginTop: '10px',
            fontFamily: 'var(--font-family-primary)',
            fontSize: '16px',
            color: '#424242',
          }}
        >
          <span>
            {product.recipeProduct.quantity} x {formatVariantPrice(product.shopifyVariant)}
          </span>
        </div>
      </div>
    </div>
  );
};
